import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';

export type Order = 'asc' | 'desc';

export interface HeadCell<ObjectType> {
    disablePadding: boolean;
    id: keyof ObjectType;
    label: string;
    numeric: boolean;
    property: string;
}

interface SortableTableProps<ObjectType> {
    onRequestSort: (event: React.MouseEvent<unknown>, property: keyof ObjectType) => void;
    order: Order;
    orderBy: string;
    headCells: HeadCell<ObjectType>[];
    lastCells?: JSX.Element;
    firstCells?: JSX.Element;
    small?: boolean;
}

export default function SortableTableHead<ObjectType>(props: SortableTableProps<ObjectType>) {
    const { order, orderBy, onRequestSort, headCells, lastCells, firstCells } = props;

    const createSortHandler = (property: keyof ObjectType) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {firstCells}
                {headCells.map((headCell) => {
                    return <TableCell
                        key={headCell.id as string}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span style={{
                                    border: 0,
                                    clip: 'rect(0 0 0 0)',
                                    height: 1,
                                    margin: -1,
                                    overflow: 'hidden',
                                    padding: 0,
                                    position: 'absolute',
                                    top: 20,
                                    width: 1,
                                }}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>;
                })}
                {lastCells}
            </TableRow>
        </TableHead>
    );
}